import React from 'react';
import { SearchIcon, ScanLineIcon, MinusIcon, PlusIcon } from 'lucide-react';
import { formatRwf } from '../../../utils/currency';
const categories = ['All', 'Groceries', 'Drinks', 'Household', 'Bakery'];
const products = [{
  name: 'Sorghum flour 2kg',
  price: 3600,
  stock: 42
}, {
  name: 'Cooking oil 1L',
  price: 2900,
  stock: 18
}, {
  name: 'Sugar 1kg',
  price: 1800,
  stock: 64
}, {
  name: 'Rice 5kg',
  price: 7500,
  stock: 23
}, {
  name: 'Milk 500ml',
  price: 700,
  stock: 90
}, {
  name: 'Bread loaf',
  price: 1200,
  stock: 35
}, {
  name: 'Soap bar',
  price: 500,
  stock: 120
}, {
  name: 'Mineral water 1.5L',
  price: 800,
  stock: 72
}, {
  name: 'Tea leaves 250g',
  price: 1500,
  stock: 40
}];
const cart = [{
  name: 'Rice 5kg',
  qty: 1,
  price: 7500
}, {
  name: 'Cooking oil 1L',
  qty: 2,
  price: 2900
}, {
  name: 'Sugar 1kg',
  qty: 1,
  price: 1800
}, {
  name: 'Milk 500ml',
  qty: 3,
  price: 700
}];
export function PosTabletScreen() {
  const subtotal = cart.reduce((s, i) => s + i.qty * i.price, 0);
  return <div className="rounded-[26px] bg-[#1A1A1A] p-[10px] shadow-[0_40px_80px_-40px_rgba(11,11,11,0.55)]" data-id="element-1291" data-mp="1dyzalgs2o8co">
      <div className="grid aspect-[4/3] grid-cols-[1.45fr_1fr] overflow-hidden rounded-[17px] bg-[#F7F7F6] text-ink" data-id="element-1292" data-mp="1ivpqa2zyt1xk">
        <div className="flex min-w-0 flex-col p-3" data-id="element-1293" data-mp="13zi7960am6jv">
          <div className="flex items-center gap-2" data-id="element-1294" data-mp="18ybkqyfkxxk1">
            <div className="flex flex-1 items-center gap-1.5 rounded-[7px] bg-white px-2 py-1.5 ring-1 ring-canvas-line" data-id="element-1295" data-mp="18x09kdjt1niw">
              <SearchIcon className="h-3 w-3 text-ink-muted" aria-hidden="true" data-id="element-1296" data-mp="zy6dcoadyz5v" />
              <span className="text-[9px] text-ink-muted" data-id="element-1297" data-mp="1009fg6otciqy">Search products</span>
            </div>
            <span className="flex h-6 w-6 items-center justify-center rounded-[7px] bg-white ring-1 ring-canvas-line" data-id="element-1298" data-mp="l75vxtrnvuxl">
              <ScanLineIcon className="h-3 w-3 text-ink" aria-hidden="true" data-id="element-1299" data-mp="c8kek1xxelye" />
            </span>
          </div>
          <div className="mt-2 flex gap-1 overflow-hidden" data-id="element-1300" data-mp="g9xmchkkwz7y">
            {categories.map((c, i) => <span key={c} className={`whitespace-nowrap rounded-full px-2 py-0.5 text-[8px] font-medium ${i === 0 ? 'bg-ink text-white' : 'bg-white text-ink-muted ring-1 ring-canvas-line'}`} data-id="element-1301" data-mp="2ixcox7fqrea3" data-mpi={i}>
                {c}
              </span>)}
          </div>
          <div className="mt-2 grid flex-1 grid-cols-3 gap-1.5" data-id="element-1302" data-mp="249j67dvczvna">
            {products.map(p => <div key={p.name} className="flex flex-col justify-between rounded-[7px] bg-white p-1.5 ring-1 ring-canvas-line" data-id="element-1303" data-mp="31uxe6fmf4ev8">
                <span className="text-[8px] font-medium leading-tight text-ink" data-id="element-1304" data-mp="2rxizakg57y51">{p.name}</span>
                <span className="mt-1" data-id="element-1305" data-mp="2rzdhvs3xze5y">
                  <span className="block text-[8.5px] font-semibold text-ink" data-id="element-1306" data-mp="2nuw2040pdl0g">{formatRwf(p.price)}</span>
                  <span className="block text-[7px] text-ink-muted" data-id="element-1307" data-mp="1gjf3r9twq1xv">{p.stock} in stock</span>
                </span>
              </div>)}
          </div>
        </div>

        <div className="flex min-w-0 flex-col border-l border-canvas-line bg-white p-3" data-id="element-1308" data-mp="3o4nnfnrwuvf2">
          <div className="flex items-center justify-between" data-id="element-1309" data-mp="3s5fxukcir6cx">
            <span className="text-[10px] font-semibold" data-id="element-1310" data-mp="3s5z95i7nywhz">Current sale</span>
            <span className="text-[8px] text-ink-muted" data-id="element-1311" data-mp="ymo2s3ntyws">Till 1 · Aline</span>
          </div>
          <ul className="mt-2 flex-1 space-y-1.5" data-id="element-1312" data-mp="5r69gb8l9yc5">
            {cart.map(item => <li key={item.name} className="flex items-center justify-between gap-1" data-id="element-1313" data-mp="aq0rvc2n9kvq">
                <span className="min-w-0" data-id="element-1314" data-mp="fnstwyx06ndn">
                  <span className="block truncate text-[8.5px] font-medium" data-id="element-1315" data-mp="fmhgs8ho439v">{item.name}</span>
                  <span className="flex items-center gap-1 text-[7.5px] text-ink-muted" data-id="element-1316" data-mp="jqffii32zc2e">
                    <MinusIcon className="h-2 w-2" aria-hidden="true" data-id="element-1317" data-mp="onph0w3qve6l" />
                    {item.qty}
                    <PlusIcon className="h-2 w-2" aria-hidden="true" data-id="element-1318" data-mp="2litvvcpz88gp" />
                  </span>
                </span>
                <span className="text-[8.5px] font-semibold" data-id="element-1319" data-mp="2qglvyu0rz0vz">{formatRwf(item.qty * item.price)}</span>
              </li>)}
          </ul>
          <div className="space-y-1 border-t border-canvas-line pt-2 text-[8px]" data-id="element-1320" data-mp="1q7m1x0zf3lvi">
            <div className="flex justify-between text-ink-muted" data-id="element-1321" data-mp="2543a5jcb8kdu">
              <span data-id="element-1322" data-mp="252ad8vri1ej1">Subtotal</span>
              <span data-id="element-1323" data-mp="205jo7ixpv8lh">{formatRwf(subtotal)}</span>
            </div>
            <div className="flex justify-between text-ink-muted" data-id="element-1324" data-mp="20375v4o1qw7w">
              <span data-id="element-1325" data-mp="1cgh6yc6zvhri">VAT incl. (18%)</span>
              <span data-id="element-1326" data-mp="1cdcukrjdlfpr">{formatRwf(Math.round(subtotal * 18 / 118))}</span>
            </div>
            <div className="flex justify-between text-[10px] font-semibold text-ink" data-id="element-1327" data-mp="17ei3l2b98kuk">
              <span data-id="element-1328" data-mp="1m6tnzuflossw">Total</span>
              <span data-id="element-1329" data-mp="1hesiqsguo2cd">{formatRwf(subtotal)}</span>
            </div>
          </div>
          <div className="mt-2 grid grid-cols-3 gap-1" data-id="element-1330" data-mp="1hcphfca8ymsc">
            {['Mobile money', 'Card', 'Cash'].map(m => <span key={m} className="rounded-[5px] bg-canvas-warm py-1 text-center text-[7px] font-medium" data-id="element-1331" data-mp="oq4ow8i1c4n7">
                {m}
              </span>)}
          </div>
          <span className="mt-1.5 rounded-[6px] bg-brand py-1.5 text-center text-[9px] font-semibold text-white" data-id="element-1332" data-mp="30bdn073519bg">
            Charge {formatRwf(subtotal)}
          </span>
        </div>
      </div>
    </div>;
}